import type { RegisterRouteFunction } from 'owa-router';

export function registerPeopleCardRoutes(registerRoute: RegisterRouteFunction) {
    const routes = [
        '/card/:routeIdType',
        '/card/:routeIdType/:routeId',
        '/card/:routeIdType/:routeId/:view',
    ];
    routes.forEach(route => registerRoute(route, () => {}));
}
